// Square rounded "X" close control for modal dialogs (matches title-section icon buttons).

import { forwardRef, type ButtonHTMLAttributes, type KeyboardEvent, type ReactElement } from 'react';

export const MODAL_CLOSE_BUTTON_CLASS =
  'flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-gray-200/80 bg-white text-gray-500 shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800';

/** @deprecated Use MODAL_CLOSE_BUTTON_CLASS */
export const MODAL_CIRCLE_CLOSE_BUTTON_CLASS = MODAL_CLOSE_BUTTON_CLASS;

type ModalCircleCloseButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'aria-label'> & {
  ariaLabel: string;
};

export const ModalCircleCloseButton = forwardRef<HTMLButtonElement, ModalCircleCloseButtonProps>(
  ({ ariaLabel, className = '', onClick, onKeyDown, ...rest }, ref): ReactElement => {
    const handleKeyDown = (e: KeyboardEvent<HTMLButtonElement>): void => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.currentTarget.click();
      }
      onKeyDown?.(e);
    };

    return (
      <button
        ref={ref}
        type="button"
        aria-label={ariaLabel}
        className={`${MODAL_CLOSE_BUTTON_CLASS} ${className}`.trim()}
        onClick={onClick}
        onKeyDown={handleKeyDown}
        {...rest}
      >
        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    );
  },
);

ModalCircleCloseButton.displayName = 'ModalCircleCloseButton';
